import actionTypes from '../actionTypes';

export function createUnionRequest( name ) {
  return {
    type: actionTypes.CREATE_UNION_REQUEST,
    name
  };
}

export function createUnionSuccess( union ) {
  return {
    type: actionTypes.CREATE_UNION_SUCCESS,
    union
  };
}

export function joinUnionRequest( unionId ) {
  return {
    type: actionTypes.JOIN_UNION_REQUEST,
    unionId
  };
}

export function joinUnionSuccess() {
  return {
    type: actionTypes.JOIN_UNION_SUCCESS
  };
}

export function disbandUnionRequest( unionId ) {
  return {
    type: actionTypes.DISBAND_UNION_REQUEST,
    unionId
  };
}

export function disbandUnionSuccess() {
  return {
    type: actionTypes.DISBAND_UNION_SUCCESS
  };
}

export function quitUnionClubRequest( unionId ) {
  return {
    type: actionTypes.QUIT_UNION_CLUB_REQUEST,
    unionId
  };
}

export function quitUnionClubSuccess() {
  return {
    type: actionTypes.QUIT_UNION_CLUB_SUCCESS
  };
}

export function unionMembersRequest( unionId ) {
  return {
    type: actionTypes.UNION_MEMBERS_REQUEST,
    unionId
  };
}

export function unionMembersSuccess( clubs ) {
  return {
    type: actionTypes.UNION_MEMBERS_SUCCESS,
    clubs
  };
}

export function unionPendingsRequest( unionId ) {
  return {
    type: actionTypes.UNION_PENDINGS_REQUEST,
    unionId
  };
}

export function unionPendingsSuccess( clubs ) {
  return {
    type: actionTypes.UNION_PENDINGS_SUCCESS,
    clubs
  };
}

export function acceptDeclineRequest({ clubId, doAccept}) {
  return {
    type: actionTypes.UNION_ACCEPT_DECLINE_CLUB_REQUEST,
    clubId,
    doAccept
  };
}

export function acceptDeclineSuccess( unionId ) {
  return {
    type: actionTypes.UNION_ACCEPT_DECLINE_CLUB_SUCCESS,
    unionId
  };
}

export function changeUnionDetails( unionDetails ) {
  return {
    type: actionTypes.UNION_CHANGE_REQUEST,
    unionDetails
  };
}

export function changeUnionDetailsSuccess( unionUpdated ) {
  return {
    type: actionTypes.UNION_CHANGE_SUCCESS,
    unionUpdated
  };
}

export function changeUnionDetailsFailure() {
  return {
    type: actionTypes.UNION_CHANGE_FAILURE
  };
}